import spinnerComponent from './spinner.component';

export default angular
  .module('fizyweb.paycell.spinner', [])
  .component('spinner', spinnerComponent).name;



// WEBPACK FOOTER //
// src/app/components/spinner/spinner.module.ts